<template>
  <div class="blockly-content">
    <!-- <img
        :src="codeIcon"
        id="btnCodeEditer"
        @click="modeToCode"
        alt="切换模式"
      /> -->
    <span class="mode-btn" id="btnCodeEditer" @click.stop="modeToCode">{{
      workspaceIsVisible ? '查看代码' : '查看积木'
    }}</span>
    <python-editor
      v-model="pythonEditorCode"
      v-show="!workspaceIsVisible"
      :readOnly="'nocursor'"
      :lineNumbers="false"
    ></python-editor>
    <div :id="'blocklyBox' + id" :class="['blockly-box-component']"></div>
    <xml :id="'toolbox' + id" style="display: none">
      <!-- <block type="gta_ai_event_1"></block> -->
    </xml>
  </div>
</template>

<script>
import Blockly from '@/assets/blockly/renderers/index.js'
import GTheme from '@/assets/blockly/theme/gtheme.js'
import BlocklLangMsg from 'BlocklLangMsg'
import PythonEditor from '@/components/common/PythonEditor'

export default {
  name: 'blockly',
  components: { PythonEditor },
  props: {
    id: {
      default: 0,
    },
    blockText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      workspace: null,
      rendererName: 'gta',
      pythonEditorCode: '',
      workspaceIsVisible: true,
      codeIcon: require('../../../public/images/ico37-1.png'),
    }
  },

  computed: {},

  watch: {
    pythonEditorCode(val){
      // console.log('pythonEditorCode,workspaceIsVisible',val,this.workspaceIsVisible)
    },
  },

  created() {},

  mounted() {
    // 主题设置
    Blockly.Theme.GTheme = new Blockly.Theme(
      GTheme.defaultBlockStyles,
      GTheme.categoryStyles
    )

    //积木渐变
    setTimeout(() => {
      this.blocksGradient()
    }, 1000)

    Blockly.SPRITE.width = 296 * 1.5 // sprite 更改 296
    require('@/assets/blockly/transhcan/trashcan.js')
    Blockly.Trashcan.prototype.MARGIN_SIDE_ = 10 //0

    // 载入编程语言y
    require('../../../public/blockly/code/python_compressed.js')
    //语言文本
    require('../../../public/blockly/msg/details/zh-hans.js')

    // 载入积木模块
    require('@/assets/blockly/blocks/gta_ai_event.js')
    require('@/assets/blockly/blocks/gta_ai_math.js')
    require('@/assets/blockly/blocks/gta_ai_text.js')
    require('@/assets/blockly/blocks/gta_ai_list.js')
    require('@/assets/blockly/blocks/gta_ai_control.js')
    require('@/assets/blockly/blocks/gta_ai_dict.js')
    require('@/assets/blockly/blocks/gta_ai_procedures.js')
    require('@/assets/blockly/blocks/gta_ai_variables.js')
    require('@/assets/blockly/blocks/gta_ai_media.js')
    require('@/assets/blockly/blocks/gta_ai_item.js')
    require('@/assets/blockly/blocks/gta_ai_robot.js')
    require('@/assets/blockly/blocks/gta_ai_robot_B.js')
    require('@/assets/blockly/blocks/gta_ai_turtle.js')
    //初始化
    this.blocklyInit()
    this.blockToWorkspace()
    // this.workspace.markFocused();//居中
    // this.workspace.setScale(1);//居中
    // this.workspace.beginCanvasTransition();//居中
    // this.workspace.scrollCenter();//居中
  },
  methods: {
    blocklyInit(oldWorkspaceXml) {
      this.workspace = Blockly.inject(
        document.getElementById(`blocklyBox${this.id}`),
        {
          media: '../../blockly/media/',
          // toolbox: document.getElementById(`toolbox${this.id}`),
          zoom: { controls: false, wheel: false },
          move: { wheel: true },
          theme: Blockly.Theme.GTheme,
          // MARK: 渲染器，用于积木的形状
          renderer: this.rendererName,
          //积木注释
          comments: false,
        }
      )
    },
    //积木脚本生成到工作台
    blockToWorkspace() {
      let reg_xml = /<xml>/
      let blockText = this.blockText
      let reg_block_text = 'type='
      let pos_y = `y="30" x="30" `
      let index = blockText.indexOf(reg_block_text)
      if (blockText && !reg_xml.test(blockText)) {
        blockText = blockText.slice(0, index) + pos_y + blockText.slice(index)
        let text = `<xml>${blockText}</xml>`
        let xmlDom = Blockly.Xml.textToDom(text)
        Blockly.Xml.domToWorkspace(xmlDom, this.workspace)
      } else if (reg_xml.test(blockText)) {
        // console.log('blockText',blockText);
        //项目案例的解析
        setTimeout(()=>{
       let blockXml=  Blockly.Xml.textToDom(blockText)
          Blockly.Xml.domToWorkspace(blockXml, this.workspace)
        },300)
      }
    },
    //代码模式的切换
    modeToCode() {
      this.workspaceIsVisible = !this.workspaceIsVisible
      this.attemptCodeGeneration(Blockly.Python)
    },
    // 将积木转化为代码
    attemptCodeGeneration(generator) {
      if (this.checkAllGeneratorFunctionsDefined(generator)) {
        var code = generator.workspaceToCode(this.workspace);
        // 处理代理字段
        if (window.location.protocol === 'https:' && !(code.indexOf('service_photoDomain') !== -1)) {
          let fileBaseUrl = window.gtaAiConfig.fileBaseUrl;
          code = code.replace(/\/service_photoDomain/g, fileBaseUrl);
        }
        this.pythonEditorCode = code;
        // console.log(' var code',code)
      }
    },
    // 检查是否所有的积木都有代码实现
    checkAllGeneratorFunctionsDefined(generator) {
      var blocks = this.workspace.getAllBlocks(false)
      var missingBlockGenerators = []

      for (var i = 0; i < blocks.length; i++) {
        var blockType = blocks[i].type
        if (!generator[blockType]) {
          if (missingBlockGenerators.indexOf(blockType) == -1) {
            missingBlockGenerators.push(blockType)
          }
        }
      }
      var valid = missingBlockGenerators.length == 0
      if (!valid) {
        var msg =
          'The generator code for the following blocks not specified for ' +
          generator.name_ +
          ':\n - ' +
          missingBlockGenerators.join('\n - ')
        Blockly.alert(msg) // Assuming synchronous. No callback.
      }
      return valid
    },
    //设置积木渐变类型
    blocksGradient() {
      var defaultBlockStyles = GTheme.defaultBlockStyles
      var blocklySvg = document.getElementsByClassName('blocklySvg')[0]
      for (var i in defaultBlockStyles) {
        var styleName = i //获取对象的键名
        var colour = defaultBlockStyles[i].colourPrimary
        var defs = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'defs'
        )
        var linearGradient = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'linearGradient'
        )
        linearGradient.setAttribute('id', styleName)
        linearGradient.setAttribute('x1', '0%')
        linearGradient.setAttribute('y1', '0%')
        linearGradient.setAttribute('x2', '100%')
        linearGradient.setAttribute('y2', '0%')
        var stop_1 = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'stop'
        )
        var stop_2 = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'stop'
        )
        stop_1.setAttribute('offset', '0%')
        stop_1.setAttribute('stop-opacity', '1')
        stop_1.setAttribute('stop-color', colour)
        stop_2.setAttribute('offset', '100%')
        stop_2.setAttribute('stop-opacity', '1')
        // stop_2.setAttribute("stop-opacity", "0.5");
        stop_2.setAttribute('stop-color', colour)
        linearGradient.appendChild(stop_1)
        linearGradient.appendChild(stop_2)
        defs.appendChild(linearGradient)
        blocklySvg.appendChild(defs)
      }
    },
  },
  beforeUpdate() {},
  updated() {},
  destroyed() {},
  activated() {},
}
</script>
<style lang="scss" scoped>
.blockly-content {
  height: 100%;
  width: 100%;
  // position: absolute;
  // top:0;
  // left:0;
  // right:0;
  // bottom:0;
  position: relative;
  .mode-btn {
    position: absolute;
    z-index:3;
    right: 10px;
    margin-top: 5px;
    cursor: pointer;
    color: #fff;
  }
  .blockly-box-component {
    width: 100%;
    height: 100%;
    text-align: left;
    /deep/.blocklySvg {
      background-color: #15234c;
    }
  }
  .space-hide {
    visibility: hidden;
  }
  /deep/.python-editor-content {
    padding-bottom: 0px;
    background-color: #15234c;
  }
}
</style>
